import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { UserService } from '@app/resources/users/users.service';
import { UtilService } from '@app-shared/services/util.service';

@Component({
    imports: [CommonModule, SharedModule, RouterModule, MatCardModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule],
    selector: 'app-verify-email-component',
    templateUrl: './verify-email-component.component.html',
    styleUrls: ['./verify-email-component.component.css']
})
export class VerifyEmailComponentComponent implements OnInit {
  token: string = '';
  isLoading: boolean = true;
  successMsg: string = '';
  errorMsg: string = '';
  serviceError: string = '';
  
  // Status display properties
  statusIcon: string = '';
  statusTitle: string = '';
  statusMessage: string = '';
  statusClass: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private util: UtilService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.params['token'];
    if (this.token) {
      this.verifyEmail();
    } else {
      this.showError('Invalid verification link');
    }
  }

  verifyEmail() {
    this.isLoading = true;
    this.successMsg = '';
    this.errorMsg = '';
    this.serviceError = '';

    this.userService.verifyEmailByToken(this.token).subscribe(
      (response: any) => {
        this.isLoading = false;
        console.log(response);
        
        // Handle the correct response format
        if (response.body.status === 'success') {
          this.showSuccess(response.body.message || 'Email verified successfully! You can now login to your account.');
          
          // Notify parent component about verification completion
          this.notifyVerificationComplete();
        } else if (response.body.status === 'error') {
          this.showError(response.body.message || 'Email verification failed. Please try again.');
        } else {
          this.showError('Email verification failed. Please try again.');
        }
        
        // Force change detection
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.isLoading = false;
        const errorMessage = error?.error?.message || 'Email verification failed. Please try again.';
        this.showError(errorMessage);
        
        // Force change detection
        this.cdr.detectChanges();
      }
    );
  }

  showSuccess(message: string) {
    this.successMsg = message;
    this.statusIcon = 'check_circle';
    this.statusTitle = 'Email Verified Successfully!';
    this.statusMessage = message;
    this.statusClass = 'status-success';
    console.log(this.successMsg);
    console.log(this.statusIcon);
    console.log(this.statusTitle);
    console.log(this.statusMessage);
    console.log(this.statusClass);
    
    // Force change detection
    this.cdr.detectChanges();
      setTimeout(() => {
    this.router.navigate(['/']); 
  }, 3000);
  }

  showError(message: string) {
    this.errorMsg = message;
    this.statusIcon = 'error';
    this.statusTitle = 'Verification Failed';
    this.statusMessage = message;
    this.statusClass = 'status-error';
    
    // Force change detection
    this.cdr.detectChanges();
  }

  notifyVerificationComplete() {
    // Store verification completion in localStorage
    localStorage.setItem('emailVerificationComplete', 'true');
    localStorage.setItem('verificationStatus', 'verified');
  
    // Dispatch custom event
    const event = new CustomEvent('emailVerificationComplete', {
      detail: {
        email: 'verified',
        status: 'verified'
      }
    });
    window.dispatchEvent(event);
  }

  goToLogin() {
    this.router.navigate(['/account']);
  }
}